export const DEVICE_STANDARD_OPTIONS = [
  '60898',
  '61009',
  '61009/62606 AFDD',
  '60947-2',
  '60947-3',
  '88-2',
  '88-3',
  '1361',
  '1362',
  '3036',
  '3871',
  '4752',
  '5419',
  '5486',
  '50439',
  '62423',
  '62606',
  'MCB',
  'MCCB',
  'ACB',
  'N/V',
  'N/A',
  'LIM',
];

export const SHORT_CIRCUIT_CAPACITY_KA_OPTIONS = [
  '6',
  '10',
  '15',
  '25',
  '33',
  '36',
];

export const SPD_RATED_CURRENT_A_OPTIONS = [
  '40',
  '50',
  '63',
  '80',
  '100',
  '125',
  '200',
  '250',
  '300',
  'N/A',
];

export const SPD_TYPE_OPTIONS = [
  'B',
  'C',
  'D',
  'K',
  'Z',
  '1',
  '2',
  '3',
  'gG',
  'gM',
  'aM',
  'S1A',
  'S2A',
  'S4A',
  'N/A',
  'N/A',
  'LIM',
];

export const MAIN_SWITCH_POLES_OPTIONS = [
  '1', '2', '3', '4', '5', 'N/A',
];

export const VOLTAGE_RATING_OPTIONS = [
  '110', '230', '240', '400', '415', '600', '1000', 'N/A',
];

export const CONDUCTOR_CSA_OPTIONS = [
  '10', '15', '16', '25', '35', '50', '70', 'N/A',
];

export const RCD_OPERATING_CURRENT_OPTIONS = [
  '10', '30', '50', '100', '200',
];

export const EARTH_CONDUCTOR_CSA_OPTIONS = [
  '0.5', '1', '1.5', '2.5', '4', '6', '10', '16', '25', '35', '50',
];


